import type { ReactNode } from "react";
import { cn } from "@/lib/utils/cn";

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
  size?: "sm" | "md" | "lg";
}

export function EmptyState({ icon, title, description, action, className, size = "md" }: EmptyStateProps) {
  const sizeMap = {
    sm: { container: "py-8", icon: "w-10 h-10 rounded-xl", iconSize: "w-5 h-5", title: "text-sm", desc: "text-xs" },
    md: { container: "py-12", icon: "w-14 h-14 rounded-2xl", iconSize: "w-7 h-7", title: "text-base", desc: "text-sm" },
    lg: { container: "py-20", icon: "w-20 h-20 rounded-3xl", iconSize: "w-10 h-10", title: "text-xl", desc: "text-base" },
  };
  const s = sizeMap[size];

  return (
    <div className={cn("flex flex-col items-center text-center", s.container, className)}>
      {icon && (
        <div className={cn("bg-muted flex items-center justify-center text-text-subtle mb-4", s.icon)}>
          <span className={s.iconSize}>{icon}</span>
        </div>
      )}
      <p className={cn("font-semibold text-foreground", s.title)}>{title}</p>
      {description && (
        <p className={cn("text-text-muted mt-1.5 max-w-xs leading-relaxed", s.desc)}>{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
